(() => {
  'use strict';
  const root = document.getElementById('BlissChatPreview');
  if (!root || root.dataset.helpMode !== 'guided' || root.dataset.liveChatEnabled !== 'false') return;
  const dialog = root.querySelector('dialog');
  const launcher = root.querySelector('.bcp__launcher');
  const close = root.querySelector('.bcp__close');
  if (!launcher || !dialog || typeof dialog.showModal !== 'function') return;
  const home = document.querySelector('.bcp-home');
  const videoFrame = document.querySelector('.bliss-editorial-hero .beh-frame');
  const heroBadge = document.querySelector('.beh-certification img');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const launcherAvatar = launcher.querySelector('.bcp__avatar');
  const panelAvatar = dialog.querySelector('.bcp__avatar');
  const launcherImage = launcherAvatar && launcherAvatar.querySelector('img');
  const avatars = [launcherAvatar, panelAvatar].filter(Boolean);
  let entrancePlayed = false;
  let scheduled = false;
  const resetAvatar = avatar => avatar.classList.remove('bcp__avatar--arriving', 'bcp__avatar--responding');
  const stopGuideMotion = () => avatars.forEach(resetAvatar);
  const respondToPointer = () => {};
  avatars.forEach(avatar => {
    avatar.addEventListener('animationend', () => resetAvatar(avatar));
    avatar.addEventListener('animationcancel', () => resetAvatar(avatar));
  });
  reducedMotion.addEventListener('change', stopGuideMotion);
  root.addEventListener('keydown', stopGuideMotion);
  root.addEventListener('focusin', stopGuideMotion);
  document.addEventListener('visibilitychange', stopGuideMotion);
  launcher.addEventListener('pointerenter', event => {
    if (event.pointerType !== 'mouse' || reducedMotion.matches || root.hidden || root.contains(document.activeElement) || !launcherAvatar) return;
    if (!launcherAvatar.classList.contains('bcp__avatar--arriving')) launcherAvatar.classList.add('bcp__avatar--responding');
  });
  const consentSelector = '#shopify-pc__banner,.shopify-pc__banner,#onetrust-banner-sdk,#CybotCookiebotDialog,.cc-window,[data-cookie-banner]';
  const visible = element => {
    const box = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < window.innerHeight && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && element.getAttribute('aria-hidden') !== 'true';
  };
  const setMetric = (name, value) => {
    const next = `${Math.ceil(value)}px`;
    if (root.style.getPropertyValue(name) !== next) root.style.setProperty(name, next);
  };
  const measure = () => {
    scheduled = false;
    const viewport = window.visualViewport;
    const height = viewport ? Math.min(window.innerHeight, viewport.height + viewport.offsetTop) : window.innerHeight;
    let ceiling = 16;
    document.querySelectorAll('header,sticky-header,.th-header,.shopify-section-header').forEach(element => {
      const box = element.getBoundingClientRect();
      if (!root.contains(element) && !element.closest('#MainContent') && visible(element) && box.bottom < height / 2) ceiling = Math.max(ceiling, box.bottom + 16);
    });
    let floor = height - 12;
    document.querySelectorAll('#StickyFloatingCTA,#PBarNextFrameWrapper').forEach(element => {
      const box = element.getBoundingClientRect();
      if (visible(element) && box.bottom >= height - 120) floor = Math.min(floor, box.top - 12);
    });
    const slot = home && home.getBoundingClientRect();
    const badge = heroBadge && heroBadge.getBoundingClientRect();
    const naturalTop = badge ? badge.bottom + 16 : (slot ? slot.top : ceiling);
    const top = Math.max(ceiling, naturalTop);
    const anchor = badge || slot;
    const edge = anchor ? Math.max(12, document.documentElement.clientWidth - anchor.right) : 12;
    setMetric('--bcp-edge', edge);
    setMetric('--bcp-top', top);
    root.dataset.dock = naturalTop > ceiling ? 'home' : 'sticky';
    const consentVisible = [...document.querySelectorAll(consentSelector)].some(visible);
    const launcherHeight = launcher.getBoundingClientRect().height || parseFloat(getComputedStyle(launcher).height) || 48;
    const video = videoFrame && videoFrame.getBoundingClientRect();
    const shouldHide = consentVisible || top + launcherHeight > floor || Boolean(video && video.bottom > top - 16);
    root.hidden = shouldHide;
    const belowTop = top + launcherHeight + 12;
    const belowRoom = Math.max(0, floor - belowTop);
    const useViewportPanel = belowRoom < 380 && (!home || height < 650);
    const panelTop = useViewportPanel ? 12 : belowTop;
    root.dataset.panelLayout = useViewportPanel ? 'viewport' : 'anchored';
    root.dataset.compactIntro = floor - panelTop < 500 ? 'true' : 'false';
    setMetric('--bcp-panel-top', panelTop);
    setMetric('--bcp-panel-height', Math.max(0, floor - panelTop));
    if (shouldHide) {
      stopGuideMotion();
      if (dialog.open) dialog.close();
    } else if (!entrancePlayed && launcherImage && launcherImage.complete && launcherImage.naturalWidth > 0) {
      entrancePlayed = true;
      if (!reducedMotion.matches && !root.contains(document.activeElement) && launcherAvatar) launcherAvatar.classList.add('bcp__avatar--arriving');
    }
  };
  const scheduleMeasure = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(measure);
  };
  launcher.addEventListener('click', () => {
    stopGuideMotion();
    measure();
    if (root.hidden || dialog.open) return;
    const room = parseFloat(root.style.getPropertyValue('--bcp-panel-height')) || 0;
    if (room < 380 && root.dataset.dock === 'home' && root.dataset.panelLayout !== 'viewport') {
      window.scrollBy({ top: Math.ceil(380 - room), behavior: 'instant' });
      measure();
      if (root.hidden) return;
    }
    dialog.showModal();
    launcher.setAttribute('aria-expanded', 'true');
    close.focus({ preventScroll: true });
  });
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    launcher.setAttribute('aria-expanded', 'false');
    if (!root.hidden) launcher.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  const choices = [...root.querySelectorAll('details[data-faq-id]')];
  const storageKey = 'bliss-chat-preview-faq-v1';
  const duration = 30 * 60 * 1000;
  let expiryTimer;
  const removeChoice = () => {
    clearTimeout(expiryTimer);
    try { window.sessionStorage.removeItem(storageKey); } catch (_) {}
  };
  const storeChoice = (id) => {
    if (!choices.some(choice => choice.dataset.faqId === id)) return;
    removeChoice();
    try { window.sessionStorage.setItem(storageKey, JSON.stringify({ id, expires: Date.now() + duration })); } catch (_) {}
    expiryTimer = setTimeout(removeChoice, duration);
  };
  let restoredId = null;
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
    if (stored && Number.isFinite(stored.expires) && stored.expires > Date.now() && stored.expires <= Date.now() + duration && choices.some(choice => choice.dataset.faqId === stored.id)) {
      restoredId = stored.id;
      expiryTimer = setTimeout(removeChoice, stored.expires - Date.now());
    } else removeChoice();
  } catch (_) { removeChoice(); }
  choices.forEach(details => {
    const summary = details.querySelector('summary');
    if (summary) summary.addEventListener('click', event => {
      if (!details.open) respondToPointer(event);
    });
    if (details.dataset.faqId === restoredId) details.open = true;
    details.addEventListener('toggle', () => {
      if (!details.open) {
        if (!choices.some(choice => choice.open)) removeChoice();
        return;
      }
      choices.forEach(other => { if (other !== details) other.open = false; });
      if (details.dataset.faqId === restoredId) { restoredId = null; return; }
      storeChoice(details.dataset.faqId);
    });
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    let stored = null;
    try { stored = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
    const valid = stored && Number.isFinite(stored.expires) && stored.expires > Date.now() && stored.expires <= Date.now() + duration && choices.some(choice => choice.dataset.faqId === stored.id);
    if (!valid) {
      removeChoice();
      restoredId = null;
      choices.forEach(choice => { choice.open = false; });
    } else {
      clearTimeout(expiryTimer);
      expiryTimer = setTimeout(removeChoice, stored.expires - Date.now());
      if (!choices.some(choice => choice.open && choice.dataset.faqId === stored.id)) {
        restoredId = stored.id;
        choices.forEach(choice => { choice.open = choice.dataset.faqId === stored.id; });
      }
    }
    measure();
  });
  root.querySelector('.bcp__clear').addEventListener('click', () => {
    removeChoice();
    restoredId = null;
    choices.forEach(choice => { choice.open = false; });
    const status = root.querySelector('.bcp__clear-status');
    status.textContent = status.dataset.cleared;
  });
  if (launcherImage) launcherImage.addEventListener('load', scheduleMeasure);
  if (heroBadge) heroBadge.addEventListener('load', scheduleMeasure);
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(scheduleMeasure);
    [home, heroBadge, videoFrame].filter(Boolean).forEach(element => observer.observe(element));
  }
  window.addEventListener('scroll', measure, { passive: true });
  window.addEventListener('resize', scheduleMeasure, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleMeasure, { passive: true });
  new MutationObserver(records => {
    if (records.some(record => !root.contains(record.target))) scheduleMeasure();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
  measure();
})();
